import { Box } from '@mui/material';
import { LogoutDashboardIcon as LogoutIcon } from '@truvhq/ui';
import { useHistory } from 'react-router-dom';

import { AnalyticsButton } from 'components/AnalyticsButton';
import { useAuth } from 'shared/lib/auth/useAuth';

type FooterProps = {
  pageName: string;
};

export const Footer = ({ pageName }: FooterProps) => {
  const { logout } = useAuth();
  const history = useHistory();

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      history.push('/');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box className="mx-auto flex w-4/5 min-w-[360px] flex-col items-center py-[60px] sm:flex-row sm:justify-end lg:w-[832px]">
      <Box className="w-[110px] -mr-2">
        <AnalyticsButton
          className="w-full justify-start whitespace-nowrap px-2 py-[10px] text-base normal-case text-grey70"
          color="inherit"
          eventName={`${pageName} - click logout`}
          onClick={handleLogout}
        >
          <LogoutIcon className="mr-4 h-5 w-5 text-grey70" />
          <span>Log out</span>
        </AnalyticsButton>
      </Box>
    </Box>
  );
};
